export default {
  computed: {
    configOptions() {
      const options = []
      this.configuration.Categories?.forEach((cat) => {
        cat.Features.forEach((opt) => {
          options.push({ shortId: opt.ShortId, name: opt.Name })
        })
      })
      return options
    },
    // Stock matching always filters on the sechsteller, so a matched stock car
    // has the configured car's engine and shows the same description.
    configuredCarEngine() {
      const { CatalogCarName, ModelName, TrimlineName } = this.configuration
      if (!CatalogCarName) return ''
      const prefix = `${ModelName} ${TrimlineName} `.trim()
      return CatalogCarName.startsWith(prefix)
        ? CatalogCarName.slice(prefix.length).trim()
        : CatalogCarName.trim()
    },
    stockMatchCars() {
      const dealer = this.matchingStockCars.resultsDealer?.slice(0, 5) || []
      const national = this.matchingStockCars.resultsCountry?.slice(0, 5) || []
      return dealer.concat(national)
    },
    referenceRows() {
      const { Color, Interior } = this.configuration
      return [
        { kind: 'color', code: Color?.Id, name: Color?.Name },
        {
          kind: 'interior',
          code: Interior?.UpholsteryColor?.Id || Interior?.Id,
          name: Interior?.UpholsteryColor?.Name,
        },
        ...this.configOptions.map((option) => ({
          kind: 'option',
          code: option.shortId,
          name: option.name,
        })),
      ].filter((row) => row.code)
    },
  },
  methods: {
    isDealerStock(car) {
      return this.matchingStockCars.resultsDealer?.includes(car) || false
    },
    stockOrigin(car) {
      return this.i18n.t(
        this.isDealerStock(car) ? '/stockmatch/komnumber/dealer' : '/stockmatch/komnumber/national'
      )
    },
    // The color row shows what the stock car has. Stock has no interior name, so the
    // interior row, like an option row, repeats the configured one and marks it missing.
    stockMatchRows(car) {
      const stockOptions = car.StockOptions?.split(' ') || []
      return this.referenceRows.map((row) => {
        if (row.kind === 'color')
          return { code: car.ColorCode, name: car.Color, matches: car.MatchColor === 1 }
        if (row.kind === 'interior') return { ...row, matches: car.MatchInterior === 1 }
        return { ...row, matches: stockOptions.includes(row.code) }
      })
    },
    stockMatchExtras(car) {
      return (car.MatchOptions || [])
        .filter((option) => option.ShortId?.length && option.TypeOption === 'OptionsMore')
        .map((option) => ({ code: option.ShortId, name: option.Name }))
    },
  },
}
